// Types
import type { CapabilitiesReducerState } from './types';

/**
 * Empty until the BFF hydrates it. An empty slice means "the BFF has not spoken
 * yet", which `isFeatureVisible` treats as inert rather than as "everything is
 * hidden" — see the selector for why.
 */
export const getCapabilitiesInitialState = (): CapabilitiesReducerState => ({});
